import { useMemo } from 'react'

import { Text } from '@vtex/shoreline'

import { formatPercent } from '~/helpers'
import { goalImageMap } from '~/modules/retailMedia/components/CampaignForm/strategies/ObjectiveBased/helpers'

import {
  Title,
  Description,
  Wrapper,
  ImageWrapper,
  ImageContent
} from './styles'

const GoalCampaignCardPureComponent: React.FC<
  GoalCampaignCardPureComponentProps
> = ({
  title,
  image,
  description,
  observation,
  recommendedForTitle,
  recommendedFor,
  adcostObjectiveTitle,
  adcostObjectiveMin,
  adcostObjectiveMax
}) => {
  const contentCard = useMemo(
    () => ({
      imgSrc: goalImageMap[image],
      adCostRange: `${formatPercent(adcostObjectiveMin, 0)} - ${formatPercent(adcostObjectiveMax, 0)}`
    }),
    [adcostObjectiveMax, adcostObjectiveMin, image]
  )

  return (
    <Wrapper>
      <ImageWrapper className="image-wrapper">
        <ImageContent src={contentCard.imgSrc} alt={title} />
      </ImageWrapper>

      <section className="text-lg-center">
        <Title>{title}</Title>
        <Description>{description}</Description>

        <section className="recommendedForWrapper mt-4 lh-1 d-md-inline d-lg-flex flex-column">
          <Text variant="caption2" color="var(--sl-fg-base-soft)">
            {recommendedForTitle}
          </Text>
          <Text variant="caption1" color="var(--sl-fg-base-soft)">
            {recommendedFor}
          </Text>
        </section>

        <p className="text-sm text-neutral-low-medium fw-semibold mt-4">
          {adcostObjectiveTitle}: {contentCard.adCostRange}
        </p>

        {!!observation && (
          <footer className="mt-4 lh-1">
            <Text
              variant="caption1"
              color="var(--sl-fg-base-disabled)"
              className="lh-1"
            >
              {observation}
            </Text>
          </footer>
        )}
      </section>
    </Wrapper>
  )
}

export default GoalCampaignCardPureComponent
